import type { StationDetailsProps } from '@metro/station-details'
import type { SchemaStationTimetable, SchemaTimetableSpan } from '../schema/types'

type DetailsTimetable = StationDetailsProps['timetable']

/** The schema's own placeholder for a day without a train. */
const NO_TRAIN = '--:--'

/**
 * A station's schema timetable in the shape the station details panel
 * draws: each direction named by the station its trains run to
 * (`destinationStationLocalName` → `headSign`, as iOS and Android name
 * it), a missing time as the schema's `--:--`. The panel used to receive
 * the schema object cast to this type, so every direction rendered
 * without its name.
 */
export function detailsTimetable(timetable: SchemaStationTimetable | undefined): DetailsTimetable {
  return {
    directions: (timetable?.directions ?? []).map((d) => ({
      headSign: d.destinationStationLocalName ?? '',
      weekdays: span(d.weekdays),
      saturdays: span(d.saturdays),
      sundays: span(d.sundays),
    })),
  }
}

function span(s: SchemaTimetableSpan | undefined): { firstTrain: string; lastTrain: string } {
  return { firstTrain: s?.firstTrain ?? NO_TRAIN, lastTrain: s?.lastTrain ?? NO_TRAIN }
}
